import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import axios from 'axios';
import { toast } from 'react-toastify';

import Modal from '../../../Atoms/Modal/Modal';
import TextInput from '../../../Atoms/Inputs/TextInput';
import Buttons from '../../../Atoms/Buttons/Buttons';
import { API_URL, securityHeaders } from '../../../../Constants';
import styles from './AddYear.module.scss';

const AddYear = ({ onSuccess, isAddOpen, onClose, item }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [values, setValues] = useState({ from: '', to: '' });

  const handleChange = (name, value) => {
    setValues((prev) => ({ ...prev, [name]: value }));
  };

  const addAcademicYear = useMutation({
    mutationFn: ({ payload, url, method }) =>
      axios({
        url: API_URL + url,
        method: method,
        data: payload,
        headers: securityHeaders,
      }),
    onSuccess: () => {
      toast.success(item ? 'تم التعديل بنجاح' : 'تمت الإضافة بنجاح');
      setIsOpen(false);
      setValues({ from: '', to: '' });
      onSuccess?.();
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || error?.message || 'Error');
    },
  });

  const handleSave = () => {
    const payload = {
      academicName: `${values.from} - ${values.to}`,
      active: true,
      startDate: values.from,
      endDate: values.to,
      isDefault: false,
    };

    const url = item
      ? `/api/Settings/EditAcademicYear/${item.id}`
      : `/api/Settings/AddAcademicYear`;

    const method = item ? 'patch' : 'post';

    addAcademicYear.mutate({ payload, url, method });
  };

  useEffect(() => {
    if (item != null) {
      const dateArray = item.label?.split('-');

      setValues({ from: dateArray?.[0]?.trim(), to: dateArray?.[1]?.trim() });
    } else {
      setValues({ from: '', to: '' });
    }
  }, [item]);

  return (
    <>
      <button className={styles.addBtn} onClick={() => setIsOpen(true)}>
        <img src='/icons/plus.svg' alt='add' />
      </button>

      {(isOpen || isAddOpen) && (
        <Modal
          title={item ? 'تعديل السنة' : 'إضافة سنة جديدة'}
          onClose={() => (setIsOpen(false), onClose())}
        >
          <div className={styles.wrapper}>
            <div className={styles.form}>
              <TextInput
                label='من'
                placeholder='مثال: 2024'
                name='from'
                value={values.from}
                onChange={handleChange}
              />

              <TextInput
                label='إلى'
                placeholder='مثال: 2025'
                name='to'
                value={values.to}
                onChange={handleChange}
              />
            </div>

            <div className={styles.actions}>
              <Buttons
                rounded
                text={
                  addAcademicYear.isLoading
                    ? 'جارٍ الحفظ...'
                    : item
                    ? 'تعديل'
                    : 'حفظ'
                }
                handleOnClick={handleSave}
                disabled={
                  !values.from || !values.to || addAcademicYear.isLoading
                }
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default AddYear;
